import styled from 'styled-components'

const SHADOW_CARD   = '0px 0px 4px 0px rgba(43,123,199,0.25)'
const SHADOW_SEARCH = '0px 0px 20px 0px rgba(43,123,199,0.25)'

/* ── Page ───────────────────────────────────────────────────── */

export const Wrapper = styled.div`
  background: white;
  min-height: 100vh;
`

/* ── Header ─────────────────────────────────────────────────── */

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 2rem 2.5rem 1.25rem;
`

export const PageIconBox = styled.div`
  width: 4.0625rem;
  height: 4.0625rem;
  border-radius: 0.9375rem;
  background: linear-gradient(223deg, rgba(0,200,248,1) 16%, rgba(104,94,252,1) 78%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const PageIconImg = styled.img`
  width: 2.125rem;
  height: 2.125rem;
  object-fit: contain;
  filter: brightness(0) invert(1);
`

export const PageTitle = styled.h1`
  font-family: Poppins;
  font-size: 2rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
  line-height: 1.15;
`

export const PageSubtitle = styled.p`
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 400;
  color: #000000;
  opacity: 0.55;
  margin: 0;
`

/* ── Search bar ─────────────────────────────────────────────── */

export const SearchArea = styled.div`
  padding: 0 2.5rem 1.5rem;
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 4.875rem;
  background: white;
  border-radius: 1.3125rem;
  box-shadow: ${SHADOW_SEARCH};
  position: relative;
`

export const SearchImg = styled.img`
  width: 2.3125rem;
  height: 2.3125rem;
  object-fit: contain;
  position: absolute;
  left: 1.4375rem;
  opacity: 0.5;
`

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: Poppins;
  font-size: 1.125rem;
  font-weight: 300;
  color: #000000;
  padding: 0 1rem 0 4.5rem;
  &::placeholder { color: #B1B8C5; }
`

export const SearchButton = styled.button`
  height: calc(100% - 1.5rem);
  padding: 0 2rem;
  background: #4465FE;
  border: none;
  border-radius: 0.8125rem;
  font-family: Poppins;
  font-size: 1.125rem;
  font-weight: 400;
  color: white;
  cursor: pointer;
  margin-right: 0.75rem;
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover { background: #3352e0; }
`

/* ── Cards list ─────────────────────────────────────────────── */

export const CardsArea = styled.div`
  padding: 0 2.5rem 3rem;
  display: flex;
  flex-direction: column;
  gap: 0.9375rem;
`

export const ItemCard = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 0.75rem;
  box-shadow: ${SHADOW_CARD};
  padding: 0 1.1875rem 0 0.9375rem;
  height: 5.125rem;
  flex-shrink: 0;
`

export const ItemLogo = styled.div`
  width: 3.625rem;
  height: 3.625rem;
  flex-shrink: 0;
  margin-right: 1.0625rem;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const ItemInfoBlock = styled.div`
  width: 18rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const ItemSpacer = styled.div`
  flex: 1;
`

export const ItemCategory = styled.span`
  font-family: Poppins;
  font-size: 0.625rem;
  font-weight: 700;
  color: ${props => props.color || '#6462FC'};
  text-transform: uppercase;
  letter-spacing: 0.08em;
`

export const ItemName = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemQtyBlock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.5rem;
  flex-shrink: 0;
`

export const ItemQtyLine = styled.span`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
  color: #000000;
`

export const AttribuerBtn = styled.button`
  width: 10.0625rem;
  height: 2.6875rem;
  background: ${props => props.disabled ? '#CACACA' : '#8EA2FF'};
  border: 1px solid ${props => props.disabled ? '#9E9E9E' : '#4465FE'};
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 1.25rem;
  font-weight: 600;
  color: white;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  flex-shrink: 0;
  transition: background 0.15s;
  &:hover { background: ${props => props.disabled ? '#CACACA' : '#4465FE'}; }
`

export const AcheterBtn = styled.button`
  height: 2.6875rem;
  padding: 0 3.25rem;
  background: #FFFFFF;
  border: 1px solid #00C4F3;
  margin-right:2rem;
  border-radius: 0.4375rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 600;
  color: #00C4F3;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  &:hover { background: #00C4F3; color: white; }
`

/* ── Empty state ────────────────────────────────────────────── */

export const EmptyRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 0.75rem;
`

export const EmptyIcon = styled.div`
  font-size: 3rem;
  line-height: 1;
`

export const EmptyTitle = styled.p`
  font-family: Poppins;
  font-size: 1.125rem;
  font-weight: 600;
  color: #000000;
  margin: 0;
`

export const EmptySubtitle = styled.p`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 400;
  color: #BABABA;
  margin: 0;
  text-align: center;
  max-width: 24rem;
`

/* ── Attribuer modal ────────────────────────────────────────── */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(33, 76, 107, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModalPanel = styled.div`
  position: relative;
  background: #FFFFFF;
  border-radius: 0.625rem;
  box-shadow: 0px 0px 4px 0px rgba(43,123,199,0.25);
  width: 64.625rem;
  height: 39.3125rem;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  padding: 0;
  border: 1px solid rgba(239, 68, 68, 0.22);
  border-radius: 7px;
  background: #FEF2F2;
  cursor: pointer;
  transition: all 0.12s;

  & img {
    width: 0.85rem;
    height: 0.85rem;
    object-fit: contain;
    display: block;
  }

  &:hover { background: #FEE2E2; border-color: #EF4444; }
  &:focus-visible { outline: 2px solid #3494FA; outline-offset: 1px; }
`

/* ── Table header row ── */
export const ModalColHeaders = styled.div`
  display: flex;
  align-items: center;
  background: #EEF0F6;
  border-bottom: 2px solid #D8DCE8;
  height: 2.875rem;
  flex-shrink: 0;
`

export const ColHeaderBox = styled.div`
  display: flex;
  align-items: center;
  flex: ${props => props.fixed ? '0 0 10rem' : 1};
  padding: 0 0.875rem;
  height: 100%;
  border-right: 1px solid #D8DCE8;
  &:last-child { border-right: none; }
`

export const ColHeaderText = styled.span`
  font-family: Poppins;
  font-size: 0.685rem;
  font-weight: 700;
  color: #5A6170;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  white-space: nowrap;
`

/* ── Search bar row ── */
export const ModalSearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.6rem 1.5rem;
  background: #F8F9FB;
  border-bottom: 1px solid #E8E8E8;
  flex-shrink: 0;
`

export const ModalSearchBar = styled.div`
  flex: 1;
  height: 2rem;
  background: #FFFFFF;
  border: 1px solid #D8D8D8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
`

export const ModalSearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-family: Poppins;
  font-size: 0.82rem;
  font-weight: 300;
  color: #000000;
  &::placeholder { color: #B1B8C5; }
`

export const ModalSearchSpacer = styled.div`
  flex: 0 0 10rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const ModalSearchBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  width: 2rem;
  border-radius: 6px;
  border: 1px solid #D8D8D8;
  background: white;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.12s;
  padding: 0;
  & img { height: 0.72rem; opacity: 0.5; }
  &:hover { background: #EEF5FF; border-color: #3494FA; & img { opacity: 1; } }
  &:disabled { cursor: default; opacity: 0.5; }
`

/* ── Table body ── */
export const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  &::-webkit-scrollbar { width: 3px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: #E8E4E4; border-radius: 1.5px; }
`

export const ModalRow = styled.div`
  display: flex;
  align-items: center;
  height: 4rem;
  border-bottom: 1px solid #EAEDF3;
  transition: background 0.12s;
  &:hover { background: #F4F7FF; }
  &:last-child { border-bottom: none; }
`

export const ModalCell = styled.div`
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  flex: 1;
  padding: 0 0.875rem;
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 1px solid #EAEDF3;
  &:last-child { border-right: none; }
  ${({ clickable }) => clickable && `
    cursor: pointer;
    &:hover { color: #3494FA; text-decoration: underline; }
  `}
`

export const ModalToggleCell = styled.div`
  flex: 0 0 10rem;
  padding: 0 0.875rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TooltipAnchor = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover [data-tooltip='true'],
  &:focus-within [data-tooltip='true'] {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) translateX(0);
  }
`

export const TooltipBubble = styled.div`
  position: absolute;
  right: calc(100% + 0.625rem);
  top: 50%;
  transform: translateY(-50%) translateX(0.375rem);
  width: 18.5rem;
  background: #214C6B;
  color: #FFFFFF;
  border-radius: 0.5rem;
  box-shadow: 0px 8px 20px rgba(33,76,107,0.22);
  padding: 0.625rem 0.75rem;
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.35;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 20;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;

  &::after {
    content: '';
    position: absolute;
    right: -0.375rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 0.375rem solid transparent;
    border-bottom: 0.375rem solid transparent;
    border-left: 0.375rem solid #214C6B;
  }
`

export const Checkbox = styled.div`
  width: 1.1875rem;
  height: 1.1875rem;
  border-radius: 0.25rem;
  border: 1px solid ${props => props.checked ? '#4465FE' : '#D9D9D9'};
  background: ${props => props.checked ? '#4465FE' : '#FFFFFF'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.4 : 1};
  flex-shrink: 0;
  position: relative;
  transition: background 0.15s, border-color 0.15s;

  ${props => props.checked && `
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 5px;
      height: 9px;
      border: 2px solid white;
      border-top: none;
      border-left: none;
      transform: translate(-50%, -65%) rotate(45deg);
    }
  `}
`

export const ModalEmptyRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  font-family: Poppins;
  font-size: 1rem;
  color: #BABABA;
`

export const PlayerCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  overflow: hidden;
`

export const InitialBubble = styled.div`
  flex-shrink: 0;
  width: 2.125rem;
  height: 2.125rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #00C4F3 0%, #6462FC 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.03em;
`

/* ── Legacy stubs (imported by old code) ────────────────────── */
export const FilterBar         = styled.div``
export const FilterTopRow      = styled.div``
export const TabsGroup         = styled.div``
export const Tab               = styled.button``
export const TabCount          = styled.span``
export const ResultsBar        = styled.div``
export const ResultsText       = styled.span``
export const ResultsBold       = styled.span``
export const TableWrapper      = styled.div``
export const TableArea         = styled.div``
export const TableCard         = styled.div``
export const TableHeader       = styled.div``
export const Th                = styled.div``
export const TBody             = styled.div``
export const Tr                = styled.div``
export const Td                = styled.div``
export const Table             = styled.table``
export const THead             = styled.thead``
export const TBodyLegacy       = styled.tbody``
export const TrLegacy          = styled.tr``
export const TdLegacy          = styled.td``
export const FormationCell     = styled.div``
export const FormationThumb    = styled.div``
export const FormationInfo     = styled.div``
export const FormationName     = styled.span``
export const FormationCategory = styled.span``
export const QtyBadge          = styled.span``
export const StatusBadge       = styled.span``
export const StatusDot         = styled.span``
export const ActionsCell       = styled.div``
export const ActionBtn         = styled.button``
export const FormationColorBar = styled.div``
export const FormationIcon     = styled.span``
export const DateText          = styled.span``
export const DurationText      = styled.span``
export const QuantityBadge     = styled.span``
export const ActionButton      = styled.button``
export const EmptyCell         = styled.td``
export const StatCard          = styled.div``
export const StatIconWrapper   = styled.div``
export const StatMeta          = styled.div``
export const StatNumber        = styled.div``
export const StatLabel         = styled.div``
export const StatsRow          = styled.div``
export const ModalBox          = styled.div``
export const ModalHeader       = styled.div``
export const ModalColorBar     = styled.div``
export const ModalClose        = styled.button``
export const ModalIcon         = styled.div``
export const ModalTitle        = styled.h3``
export const ModalSubtitle     = styled.p``
export const ModalDivider      = styled.div``
export const ModalLabel        = styled.span``
export const ModalValue        = styled.span``
export const DownloadButton    = styled.a``
